export default function Pagination({ page, pageCount, onChange, totalCount, pageSize }) {
  if (pageCount <= 1) return null;

  const pages = [];
  const start = Math.max(1, page - 2);
  const end = Math.min(pageCount, start + 4);
  for (let i = Math.max(1, end - 4); i <= end; i++) pages.push(i);

  const btnStyle = (active) => ({
    minWidth: '34px',
    height: '34px',
    padding: '0 8px',
    borderRadius: '8px',
    border: active ? '1.5px solid #1e40af' : '1px solid #e2e8f0',
    background: active ? '#1e40af' : 'white',
    color: active ? 'white' : '#374151',
    fontWeight: 700,
    fontSize: '0.85rem',
    cursor: 'pointer',
  });

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px', padding: '16px 4px 4px' }}>
      <div style={{ fontSize: '0.8rem', color: '#64748b' }}>
        {totalCount != null && (
          <>Page {page} / {pageCount} — {totalCount} résultat{totalCount !== 1 ? 's' : ''}</>
        )}
      </div>
      <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
        <button style={btnStyle(false)} disabled={page <= 1} onClick={() => onChange(page - 1)}>‹</button>
        {start > 1 && <span style={{ padding: '0 4px', color: '#94a3b8' }}>…</span>}
        {pages.map(p => (
          <button key={p} style={btnStyle(p === page)} onClick={() => onChange(p)}>{p}</button>
        ))}
        {end < pageCount && <span style={{ padding: '0 4px', color: '#94a3b8' }}>…</span>}
        <button style={btnStyle(false)} disabled={page >= pageCount} onClick={() => onChange(page + 1)}>›</button>
      </div>
    </div>
  );
}
